<template>
  <v-container grid-list-xl>
    <v-row wrap>
      <v-col cols="12">
        <m-alert type="info" show :info="'Anda berada pada program Diklat GTK <strong> ' + current_instansi.nama + '</strong>. Ingin beralih ke Seri lain? '">
          <template v-slot:default>
            <a class="primary--text font-weight-bold" @click="toDashboard()"> Klik disini </a>
          </template>
        </m-alert>
        <m-card-list
          title="Daftar Kelas"
          search
          id-key
          :add="isCan('kelas-enrol')"
          addText="Kelas"
          addHint="Tambah Kelas"
          filter
          refresh
          :variablePencarian="[{ key: 'Nama', value: 's' }]"
          @refresh="load"
          :items="items"
          footerLabel="Kelas"
          @search="
            search => {
              dataPencarian = search;
              load();
            }
          "
          :page="page"
          @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
          @add="add"
          footer
        >
          <template v-slot:items="{ item }">
            <v-row class="mx-3 my-2">
              <v-col v-for="(content, i) in grid" :key="i" v-bind="content.grid" :class="content.class + ' d-sm-flex'" :align="content.align" :justify="content.justify">
                <template v-if="content.type == 'icon'">
                  <v-avatar v-bind="content.avatar">
                    <v-img :src="item.cover ? item.cover : 'img/no-image.jpeg'"></v-img>
                  </v-avatar>
                </template>
                <template v-else-if="content.type == 'multi'">
                  <v-row>
                    <v-col v-for="(conts, index) in content.contents" :key="index" v-bind="conts.grid">
                      <template v-for="cont in conts.content">
                        <div :key="cont.name">
                          <router-link
                            :class="cont.class"
                            v-if="cont.type == 'router-link'"
                            :to="{ name: 'kelas.detail', params: { instansi_id: item.instansi_id, diklat_id: item.diklat.id, kelas_id: item.id } }"
                          >
                            {{ pVal(item, "nama") }} <span v-if="item.angkatan">({{ pVal(item.angkatan, "nama") }})</span>
                          </router-link>
                          <div v-else-if="cont.type == 'status'">
                            <span v-if="item.jenis != null" :class="item.jenis.is_daring == 1 ? 'success--text' : 'warning--warning'">{{
                              item.jenis.is_daring == 1 ? "DARING" : "LURING"
                            }}</span>
                          </div>
                          <div v-else-if="cont.type == 'timelapse'">
                            <v-icon
                              small
                              :color="$tools.checkKelasRunningST(item.server_time, item) ? 'info' : $tools.parseIsBefore(item.server_time, item.tanggal_mulai) ? 'warning' : 'grey'"
                              >mdi-timelapse</v-icon
                            >
                            <span class="caption mx-1">{{
                              $tools.checkKelasRunningST(item.server_time, item)
                                ? "Sedang Berlangsung"
                                : $tools.parseIsBefore(item.server_time, item.tanggal_mulai)
                                ? "Belum dimulai"
                                : "Sudah Selesai"
                            }}</span>
                          </div>
                          <div v-else-if="cont.type == 'button'" class="py-0 my-0">
                            <m-button
                              :icon="cont.icon"
                              :isBlock="cont.block"
                              :disabled="cont.disabled"
                              depressed
                              :color="cont.color"
                              :textButton="cont.text"
                              action="toCourse"
                              @toCourse="toCourse(item)"
                            ></m-button>
                          </div>
                          <p v-else-if="cont.type == 'date'" :class="cont.class">
                            <span>{{ wrapObj(cont.name, item) | toDT }}</span>
                          </p>
                          <p v-else-if="cont.type == 'label'" class="py-0 my-0">
                            <span :class="cont.statusColor.statusColor(item[cont.name]) + '--text'">{{ pVal(item.status_kelas, "keterangan") }}</span>
                          </p>
                          <component v-else :is="cont.component" :class="cont.class">{{ cont.label ? cont.label : wrapObj(cont.name, item) }}</component>
                        </div>
                      </template>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
              <v-col cols="1" sm="1" md="1" lg="1" xl="1">
                <p class="caption black--text my-0 py-0">Aksi</p>
                <m-menu left style="float: right" :items="more_menu" :object="item" />
              </v-col>
            </v-row>
            <v-divider />
          </template>
        </m-card-list>
      </v-col>
      <ChangeDlg ref="dlg" />
      <FormUnggahNilai ref="unggahNilaiDlg" />
    </v-row>
  </v-container>
</template>

<script>
import { ALERT_INFO, PASSPORT } from "@/const";
import { isCan } from "@/tools";
import FormUnggahNilai from "../components/FormUnggahNilai.vue";
import ChangeDlg from "../components/Form.vue";
import FilterKelas from "@/filter/FilterKelas.vue";

//@group Global Feature
export default {
  name: "kelas-list",
  components: {
    ChangeDlg,
    FilterKelas,
    FormUnggahNilai
  },
  data() {
    return {
      alert: ALERT_INFO,
      items: [],
      itemMapels: [],
      peran: null,
      dataPencarian: null,
      page: null,
      cp: 1,
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Pratinjau",
          icon: "mdi-eye",
          color: "info",
          click: (i, o) =>
            this.$router.push({
              name: "kelas.detail",
              params: {
                instansi_id: o.instansi_id,
                diklat_id: o.diklat_id,
                kelas_id: o.id
              }
            })
        },
        {
          title: "Publikasi",
          icon: "mdi-check",
          color: "success",
          click: (i, o) => this.publikasi(o),
          check: (i, o) => (isCan("kelas") && o.status_id == 1 && o.is_selfenrol == 0 ? true : o.status_id == 1 && this.current_user.is_super_admin ? true : false)
        },
        {
          title: "Batal Publikasi",
          icon: "mdi-close",
          color: "error",
          click: (i, o) => this.batalPublikasi(o),
          check: (i, o) => (this.current_user.is_super_admin && o.status_id == 2 ? true : false)
        },
        {
          title: "Ubah (Admin)",
          icon: "mdi-pencil-lock-outline",
          color: "grey",
          click: (i, o) => this.edit(o),
          check: (i, o) => this.current_user.is_super_admin || (isCan("kelas") && o.status_id == 1 && o.is_selfenrol == 0 ? true : false)
        },
        {
          title: "Ubah",
          icon: "mdi-pencil",
          color: "orange",
          click: (i, o) => this.edit(o),
          check: (i, o) => (isCan("kelas") && o.status_id == 1 && o.is_selfenrol == 1 && this.current_user.is_super_admin ? true : false)
        },
        {
          title: "Hapus",
          icon: "mdi-delete",
          color: "error",
          click: (i, o) => this.hapus(o),
          check: (i, o) => (isCan("kelas") && o.status_id == 1 && o.is_selfenrol == 0 ? true : false)
        },
        {
          title: "Unduh Peserta",
          icon: "mdi-file-pdf",
          color: "success",
          click: (i, o) => this.unduhPeserta(o)
        },
        {
          title: "Unggah Nilai",
          icon: "mdi-upload",
          color: "warning",
          click: (i, o) => this.unggahNilai(o),
          check: () => (this.current_user.is_super_admin ? true : false)
        }
      ]
    };
  },
  computed: {
    grid() {
      const conf = [
        {
          grid: { cols: 12, sm: 1, md: 1, lg: 1 },
          type: "icon",
          avatar: {
            width: 50,
            height: 50,
            size: 45,
            color: "secondary2"
          },
          class: "d-none"
        },
        {
          grid: { cols: 10, sm: 10, md: 10, lg: 10 },
          type: "multi",
          contents: [
            {
              grid: { cols: 12, sm: 4, md: 4, lg: 4 },
              content: [
                {
                  label: "Kelas",
                  class: "black--text my-0 py-0 align-left",
                  component: "p"
                },
                {
                  name: "nama",
                  class: "primary--text font-weight-bold",
                  type: "router-link"
                },
                {
                  label: "Jenis",
                  class: "mb-0 pb-0 mt-3 black--text align-left",
                  component: "p"
                },
                {
                  type: "status"
                }
              ]
            },
            {
              grid: {
                cols: 12,
                sm: this.current_user && this.current_user.is_super_admin ? "3" : "5",
                md: this.current_user && this.current_user.is_super_admin ? "3" : "5",
                lg: this.current_user && this.current_user.is_super_admin ? "3" : "5"
              },
              content: [
                {
                  label: "Tanggal Pelaksanaan",
                  class: "my-0 py-0 black--text",
                  component: "p"
                },
                {
                  label: "Tanggal Mulai",
                  class: "caption my-0 py-0 black--text",
                  component: "p"
                },
                {
                  name: "tanggal_mulai",
                  class: "my-0 py-0",
                  type: "date"
                },
                {
                  label: "s/d",
                  class: "py-0 my-0",
                  component: "p"
                },
                {
                  label: "Tanggal Selesai",
                  class: "caption my-0 py-0 black--text",
                  component: "p"
                },
                {
                  name: "tanggal_selesai",
                  class: "my-0 py-0",
                  type: "date"
                },
                {
                  type: "timelapse"
                }
              ]
            },
            {
              grid: { cols: 12, sm: 2, md: 2, lg: 2 },
              content: [
                {
                  label: "Status",
                  class: "my-0 py-0 black--text",
                  component: "p"
                },
                {
                  name: "status_id",
                  statusColor: this.$kelas,
                  type: "label"
                }
              ]
            },
            {
              grid: { cols: 12, sm: 2, md: 2, lg: 2 },
              content: [
                {
                  label: "Tautan LMS",
                  class: "my-0 py-0 black--text",
                  component: "p"
                },
                {
                  name: "link_kelas",
                  type: "button",
                  color: "success",
                  text: "Tautan",
                  icon: "mdi-link",
                  block: false,
                  disabled: false
                }
              ]
            }
          ]
        }
      ];
      return conf;
    },
    //@vuese
    //pengecekan apakah memiliki akses kelola kelas (CRUD kelas)
    addData() {
      return isCan("kelas");
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    //@vuese
    //kembali ke halaman kelola seri
    toDashboard() {
      this.$router.push({ name: "instansi.pilih.admin" });
    },
    //@vuese
    //menampilkan daftar kelas sesuai instansi aktif dan parameter yang digunakan
    load() {
      var params = {
        page: this.cp,
        peran: this.peran
      };

      if (this.dataPencarian) {
        var param = this.dataPencarian.param.value;
        params[param] = this.dataPencarian.s;
      }

      return this.$store
        .dispatch("kelas/get", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    filter(data) {
      this.peran = data.peran;
      this.load();
    },
    //@vuese
    //tampilkan form input kelas
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    unggahNilai(o) {
      this.$refs.unggahNilaiDlg.open(o).then(() => {
        this.load();
      });
    },
    //@vuese
    //tampilkan form edit kelas
    // @args objek kelas
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    //@vuese
    //publikasikan kelas
    // @args objek kelas
    publikasi(item) {
      this.$confirm(
        `Apakah Anda yakin akan mempublikasi kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/publish", item))
        .then(res => {
          if (res.error) {
            this.$error("Publikasi kelas " + item.nama + " gagal");
          } else {
            this.$info("Publikasi kelas " + item.nama + " berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //batal publikasi kelas
    // @args objek kelas
    batalPublikasi(item) {
      this.$confirm(
        `Apakah Anda yakin akan membatalkan publikasi kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>
        Anda tidak dapat mengubah data kelas dan peserta kelas setelah kelas dipublikasi`
      )
        .then(() => this.$store.dispatch("kelas/unpublish", item))
        .then(res => {
          if (res.error) {
            this.$error("Batal Publikasi kelas gagal");
          } else {
            this.$info("Batal Publikasi kelas " + item.nama + " berhasil");
          }
        })
        .then(() => this.load())
        .catch(e => e);
    },
    //@vuese
    //hapus kelas
    // @args objek kelas
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus kelas ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`
      )
        .then(() => this.$store.dispatch("kelas/drop", item))
        .then(() => {
          this.$info("Kelas " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    },
    unduhPeserta(val) {
      return this.$store
        .dispatch("kelas/unduhPeserta", {
          instansi_id: this.instansi_id,
          kelas_id: val.id,
          token: null
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    //@vuese
    //menuju link lms
    // @args objek kelas
    toCourse(val) {
      if (val.jenis.tag == "lms") {
        window.open(PASSPORT + val.link_kelas, "_blank");
      } else {
        window.open(val.url_kelas, "_blank");
      }
    },
    wrapObj(path, obj) {
      var context = obj || this;
      path = path.split(".");

      for (var i = 0; i < path.length; i++) {
        context = context[path[i]];
      }

      return context;
    }
  },
  watch: {
    instansi_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.load();
      }
    }
  }
};
</script>
